import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-confirmdialog',
  templateUrl: './confirmdialog.component.html',
  styleUrls: ['./confirmdialog.component.scss']
})
export class ConfirmdialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
